import { Pipe, PipeTransform } from '@angular/core';
import { parsePhoneNumber } from 'libphonenumber-js';

@Pipe({
  name: 'phoneNumber'
})
export class PhoneNumberPipe implements PipeTransform {

  transform(phoneValue: any, country: string = 'DE'): any {
    if (!phoneValue) {
      return '';
    }

    try {
      const phoneNumber = parsePhoneNumber(phoneValue);
      return phoneNumber.formatNational()
    } catch (error) {
      return phoneValue;
    }
  }
}
